import apiHandler from "../core/apiHandler";

const purchaseTicketsPdfApi = apiHandler('pdf/purchase-tickets');
export default purchaseTicketsPdfApi;
